import * as React from 'react';
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { useState } from "react";
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import useStore from "../../../../store/store";


const RightRegulatorComponent = () => {
    // inactive buttons and static value 0.05 always
    const [value, setValue] = useState(0.05);
    const [selectedIndex, setSelectedIndex] = useState(18);

    const stepValues = ['50', '20', '10', '5', '2', '1', '0.5', '0.2', '0.1',  50, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05]

    const eng = useStore((state) => state.eng);
    const changeRightRegulatorValue = useStore((state) => state.changeRightRegulatorValue);

    const handleIncrement = () => {
        const currentIndex = stepValues.indexOf(value);
        const nextIndex = Math.min(currentIndex + 1, stepValues.length - 1);
        setValue(stepValues[nextIndex]);
        setSelectedIndex(nextIndex);
        changeRightRegulatorValue(stepValues[nextIndex])
    };

    const handleDecrement = () => {
        const currentIndex = stepValues.indexOf(value);
        const nextIndex = Math.max(currentIndex - 1, 0);
        setValue(stepValues[nextIndex]);
        setSelectedIndex(nextIndex);
        changeRightRegulatorValue(stepValues[nextIndex])
    };

    const handleResetLeft = () => {
        setValue('50');
        setSelectedIndex(stepValues.indexOf('50'));
        changeRightRegulatorValue('50')
    };

    const handleResetRight = () => {
        setValue(0.05);
        setSelectedIndex(stepValues.indexOf(0.05));
        changeRightRegulatorValue(0.05)
    };

    const rotationAngle = (selectedIndex / stepValues.length) * 360;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '5px' }}>
                {/*<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>*/}
                {/*    <Box sx={{marginBottom: '-50px', marginLeft: '-20px'}}>0.2</Box>*/}
                {/*    <Box sx={{marginBottom: '-5px', marginLeft: '15px'}}>0.1</Box>*/}
                {/*    <Box sx={{ marginRight: '-35px', marginLeft: '13px'}}>50</Box>*/}
                {/*    <Box sx={{marginRight: '10px', marginLeft: '50px'}}>20</Box>*/}
                {/*    <Box sx={{marginLeft: '5px', marginBottom: '-20px'}}>10</Box>*/}
                {/*</Box>*/}
                <Box sx={{display: 'flex'}}>
                    {/*<Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>*/}
                    {/*    <Box></Box>*/}
                    {/*    <Box sx={{marginBottom: '-10px', marginLeft: '10px'}}>0.5</Box>*/}
                    {/*    <Box sx={{marginBottom: '10px', marginLeft: '10px'}}>1</Box>*/}
                    {/*    <Box sx={{marginBottom: '10px', marginLeft: '10px'}}>2</Box>*/}
                    {/*    <Box sx={{marginLeft: '20px', marginBottom: '15px'}}>5</Box>*/}
                    {/*</Box>*/}
                    <Box
                        sx={{
                            position: 'relative',
                            width: '75px',
                            height: '75px',
                            borderRadius: '50%',
                            backgroundColor: 'gray',
                            fontSize: '1.2em',
                            cursor: 'pointer',
                            overflow: 'hidden',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: '70%',
                                left: '50%',
                                transform: `translate(-50%, -50%) rotate(${rotationAngle}deg)`,
                                width: '2px',
                                height: '35px',
                                backgroundColor: 'black',
                                transformOrigin: 'top',
                            }}
                        />
                    </Box>
                    {/*<Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', marginBottom: '20px'}}>*/}
                    {/*    <Box sx={{marginLeft: '-20px'}}>5</Box>*/}
                    {/*    <Box sx={{marginLeft: '-5px'}}>2</Box>*/}
                    {/*    <Box >1</Box>*/}
                    {/*    <Box sx={{marginBottom: '10px'}}>0.5</Box>*/}
                    {/*    <Box sx={{marginLeft: '-7px'}}>0.2</Box>*/}

                    {/*</Box>*/}
                </Box>
                {/*<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'space-between', width: '170px' }}>*/}
                {/*    <Box sx={{marginTop: '-15px'}}>10</Box>*/}
                {/*    <Box>20</Box>*/}
                {/*    <Box sx={{marginRight: '-4px'}}>50</Box>*/}
                {/*    <Box >0.05</Box>*/}
                {/*    <Box sx={{marginTop: '-15px'}}>0.1</Box>*/}
                {/*</Box>*/}

                {/*<Box sx={{ display: 'flex', marginTop: '15px' }}>*/}
                {/*    <button onClick={handleResetLeft}><KeyboardDoubleArrowLeftIcon/></button>*/}
                {/*    <button onClick={handleDecrement}><ReplayIcon/></button>*/}
                {/*    <button onClick={handleIncrement}><RefreshIcon/></button>*/}
                {/*    <button onClick={handleResetRight}><KeyboardDoubleArrowRightIcon/></button>*/}
                {/*</Box>*/}
                <Box sx={{display: 'flex', flexDirection: 'column', fontWeight: 'bold', marginTop: '10px'}}>
                    <Typography sx={{color: '#307771', fontWeight: 'bold'}}>{eng ? 'SMOOTHLY' : 'ПЛАВНО'}</Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default RightRegulatorComponent;
